import _defineProperty from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _extends from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { CucinaIcon, SalaIcon, BarIcon, ReceptionIcon } from '../';
import { jsx as _jsx } from "react/jsx-runtime";
export var quickFilterIcons;

(function (quickFilterIcons) {
  quickFilterIcons["sala"] = "SalaIcon";
  quickFilterIcons["cucina"] = "CucinaIcon";
  quickFilterIcons["bar"] = "BarIcon";
  quickFilterIcons["reception"] = "ReceptionIcon";
})(quickFilterIcons || (quickFilterIcons = {}));

export var domainInterestOptions = [{
  key: 'sala',
  id: '',
  label: 'Sala',
  icon: quickFilterIcons.sala,
  iconElement: function iconElement(_ref) {
    var rest = _extends({}, _ref);

    return /*#__PURE__*/_jsx(SalaIcon, _objectSpread({}, rest));
  }
}, {
  key: 'cucina',
  id: '',
  label: 'Cucina',
  icon: quickFilterIcons.cucina,
  iconElement: function iconElement(_ref2) {
    var rest = _extends({}, _ref2);

    return /*#__PURE__*/_jsx(CucinaIcon, _objectSpread({}, rest));
  }
}, {
  key: 'bar',
  id: '',
  label: 'Bar',
  icon: quickFilterIcons.bar,
  iconElement: function iconElement(_ref3) {
    var rest = _extends({}, _ref3);

    return /*#__PURE__*/_jsx(BarIcon, _objectSpread({}, rest));
  }
}, {
  key: 'reception',
  id: '',
  label: 'Hotellerie',
  icon: quickFilterIcons.reception,
  iconElement: function iconElement(_ref4) {
    var rest = _extends({}, _ref4);

    return /*#__PURE__*/_jsx(ReceptionIcon, _objectSpread({}, rest));
  }
}];